module.exports = __webpack_public_path__ + "static/assets/2bb5e7c2c898e448cf611bffc4774feb.svg";